// ui/MetaRow: the one separator style (owner ruling 2026-09-29). Items in a run (a post's time and
// client, counts, footer links, labels) sit apart with a whitespace gap instead of a middle dot.
// Each child becomes its own flex item, and empty children are dropped, so an optional item never
// leaves a double gap.
import { Children, Fragment, type ReactNode } from 'react';
import styled from 'styled-components';

const Row = styled.span<{ $block: boolean }>`
  display: ${({ $block }) => ($block ? 'flex' : 'inline-flex')};
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 0.9em;
  row-gap: 0.15em;
  min-width: 0;
`;

const Item = styled.span`
  min-width: 0;
`;

export interface MetaRowProps {
  children: ReactNode;
  /** Render as a block-level flex row instead of inline. */
  block?: boolean;
  className?: string;
  'aria-label'?: string;
}

export function MetaRow({ children, block = false, className, ...rest }: MetaRowProps) {
  const items = Children.toArray(children).filter((c) => c !== '' && c !== ' ');
  // A plain space between items: a flex row never renders whitespace-only text, so the look is
  // unchanged, but accessible names, screen readers and copied text read "Friends 1", not "Friends1".
  return (
    <Row $block={block} className={className} {...rest}>
      {items.map((child, i) => (
        <Fragment key={i}>
          {i > 0 && ' '}
          <Item>{child}</Item>
        </Fragment>
      ))}
    </Row>
  );
}
